import { alpha } from "@mui/material/styles";

// プロジェクトで使用
export const PROJECT_COLOR = "#8859E4";
export const PROJECT_COLOR_LIGHT = "#AF6DDE";
export const PROJECT_COLOR_DARK = "#7748d6";

// 求人で使用
export const JOB_COLOR = "#5A62DE";
export const JOB_COLOR_LIGHT = "#6D98DE";
export const JOB_COLOR_DARK = "#4951D0";

// 削除ボタンなどで使用
export const GRAY_COLOR = "#ACACAC";
export const GRAY_COLOR_LIGHT = "#E0E0E0";
export const GRAY_COLOR_DARK = "#7A7A7A";

// 送信、更新ボタンなどで使用
export const SEND_COLOR = "#007bff";
export const SEND_COLOR_DARK = "#006AF1";

// 絞り込み検索UIで使用するカラー定義
// 絞り込み条件をクリアする「リセット」ボタン用の背景色
export const GRAY_TEXT_COLOR = "#808080";
// スマホ: 絞り込み条件で「選択済み」の項目テキスト色
export const SELECTED_COLOR = "#545454";

// テキストカラー（共通）
export const TEXT_COLOR_PRIMARY = "#333333";

// ボーダーカラー
export const BORDER_COLOR_LIGHT = "#D2D2D2";

/**
 * 求人(job) / プロジェクト(project) で使用する共通カラーを返す関数。
 *
 * - job    → "#5A62DE"
 * - project → "#8859E4"
 *
 * どのコンポーネントでも同じロジックを使えるように共通化している。
 */
export const getTypeColor = (type) => {
  return type === "job" ? JOB_COLOR : PROJECT_COLOR;
};

export const getTypeLightColor = (type) => {
  return type === "job" ? JOB_COLOR_LIGHT : PROJECT_COLOR_LIGHT;
};

export const getTypeDarkColor = (type) => {
  return type === "job" ? JOB_COLOR_DARK : PROJECT_COLOR_DARK;
};

/**
 * 未読・既読に応じて使用するテキストカラーを返す
 */
export const getReadStatusColor = (theme, isNew) => {
  return isNew ? theme.palette.text.primary : theme.palette.text.secondary;
};

/**
 * スキルバッジで使用する色味セットを返す
 *
 * - bgStrong  : 強調表示（NEWなど）
 * - bgDefault : 通常表示
 * - textStrong: 強調テキスト
 * - textDefault  : 通常テキスト
 * - border    : 通常表示用ボーダー
 */
export const getSkillBadgeColorSet = (type) => {
  const baseColor = getTypeColor(type);

  return {
    base: baseColor,
    bgStrong: alpha(baseColor, 0.15),
    bgDefault: alpha(baseColor, 0.07),
    textStrong: baseColor,
    textDefault: alpha(baseColor, 0.7),
    border: `1px solid ${alpha(baseColor, 0.15)}`,
  };
};

/**
 * スキルレベルごとの背景グラデーション定義
 */
export const SKILL_LEVEL_COLORS = {
  S: {
    outerStart: "#2991FF",
    outerEnd: "#74E8FF",
    innerStart: "#4951D0",
    innerEnd: "#00D4FF",
  },
  A: {
    outerStart: "#EBAB35",
    outerEnd: "#FFEE7F",
    innerStart: "#D08F16",
    innerEnd: "#FFE32C",
  },
  B: {
    outerStart: "#ACACAC",
    outerEnd: "#E9E9E9",
    innerStart: "#7F7F7F",
    innerEnd: "#E3E3E3",
  },
  C: {
    outerStart: "#AF6A45",
    outerEnd: "#F6B694",
    innerStart: "#915332",
    innerEnd: "#EE9D72",
  },
  D: {
    outerStart: "#71B65E",
    outerEnd: "#C6F2BA",
    innerStart: "#529C3E",
    innerEnd: "#B4E8A6",
  },
};
